import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { designFontFamily } from "services/constants/designTokens";
import { AdvanceSalary } from "../AdvanceSalary";
import { ExpenseClaim } from "../Expense/ExpenseClaim";

// The two Finance Requests screens live behind a shared tab bar, mirroring the
// Attendance Requests > Permission/On Duty pattern. `initialTab` is driven by
// the My Requests sidebar's nested links (see MyZoneApply/index.js) so the tab
// bar both reflects and can be driven from the sidebar.
const TABS = [
  { key: "advance", label: "Salary Advance" },
  { key: "expense", label: "Reimbursement" },
];

export const FinanceRequests = ({
  initialTab,
  subModuleId,
  showFullPage,
  setShowFullPage,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab || "advance");

  // Follow the sidebar's nested Finance links when they change the tab.
  useEffect(() => {
    if (initialTab && TABS.some((t) => t.key === initialTab)) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  return (
    <Box sx={{ width: "100%", fontFamily: designFontFamily }}>
      {activeTab === "expense" ? (
        <ExpenseClaim subModuleId={subModuleId} />
      ) : (
        <AdvanceSalary
          subModuleId={subModuleId}
          showFullPage={showFullPage}
          setShowFullPage={setShowFullPage}
        />
      )}
    </Box>
  );
};

export default FinanceRequests;
